import IConditionalRuleContainer from "~/models/conditionalRules/conditionalRuleContainer";
import ConditionalRuleSet from "~/models/conditionalRules/conditionalRuleSet";
import {IConditionalRuleOptions} from "~/interfaces/modeling/conditionalRuleInterfaces";

export default {
  props: {
    parent: Object as () => IConditionalRuleContainer,
    ruleSet: Object as () => ConditionalRuleSet,
    conditionalRuleOptions: {
      type: Object as () => IConditionalRuleOptions,
      default: () => {}
    },
    header: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    contextText: {
      type: String,
      default: '',
    },
    configCompleteText: {
      type: String,
      default: 'Save',
    },
    flashMessages: {
      type: [Object, String, Array, Function],
      default: "You must complete the formula before you can continue."
    }
  },
};